import { ReducerRegistry } from 'store';
import {
  FETCH_GUIDES_ASYNC,
  FETCH_GUIDES_ASYNC_END,
  FETCH_GUIDES_END_COMPLETE,
} from 'store/types';

const INIT_STATE = {
  inProgress: false,
  guides: [],
  pagination: {
    page: 1,
    limit: 15,
  },
};

export const guidesReducer = ReducerRegistry.register(
  'guides',
  (state = INIT_STATE, { type, payload, subType }) => {
    switch (type) {
      case FETCH_GUIDES_ASYNC:
        return {
          ...state,
          inProgress: true,
        };

      case FETCH_GUIDES_END_COMPLETE:
        return {
          ...state,
          inProgress: false,
          guides: [...payload.list],
          pagination: { ...payload.pagination },
        };
      case FETCH_GUIDES_ASYNC_END:
        return {
          ...state,
          inProgress: false,
        };
      default:
        return state;
    }
  },
);
